export default "__VITE_ASSET__DI7ZVG3g__"